export enum RequestState {
	NEW = 'new',
	IN_PROGRESS = 'inProgress',
	WAITING = 'waiting',
}
